// extracted by mini-css-extract-plugin
module.exports = {"prescription-labels":"prescriptionLabels_prescription-labels__pQHg7"};